import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=872533b4&scoped=true&"
import script from "./Password.vue?vue&type=script&lang=js&"
export * from "./Password.vue?vue&type=script&lang=js&"
import style0 from "./Password.vue?vue&type=style&index=0&id=872533b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872533b4",
  null
  
)

export default component.exports